import React from 'react';
import {Button} from 'antd-mobile';
import SportSwiperCard, {SportsItem} from './swiper-card';
import HomeFloorHeader from '@/pages/home/components/home-floor-header';

interface SportFloorProps {
  icon: string;
  title: string;
  hasLink?: boolean;
  hasLiveIcon?: boolean;
  sportsList: SportsItem[];
  isSport?: boolean;
  defaultSportIcon?: string;
  onLinkClick?: () => void;
}

const PreIcon = () => {
  return (
    <Button className="bg-[var(--live-bg)] text-white rounded-[0.325rem] text-xs w-[2.5rem] h-[1.2rem] font-size-10 flex items-center justify-center ml-2">
      Live
    </Button>
  );
};

const SportFloor = ({
  title,
  hasLink,
  hasLiveIcon,
  isSport,
  sportsList,
  defaultSportIcon,
  onLinkClick,
}: SportFloorProps) => {
  return (
    <div className="flex flex-col">
      <HomeFloorHeader
        color={'#D9DFED'}
        title={title}
        titleExtra={hasLiveIcon ? <PreIcon /> : null}
        titleIcon={require('@assets/icons/home/little.webp')}
        titleIconSize={16}
        showRightDom
        hasRightPadding={false}
        rightDom={
          hasLink ? (
            <div
              onClick={onLinkClick}
              className="text-t1 text-xs font-bold mr-3">
              All
            </div>
          ) : undefined
        }
      />
      <div className="w-full pb-3">
        <div className="flex flex-row gap-2 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
          {sportsList?.map((item, index) => (
            <SportSwiperCard
              key={index}
              item={item}
              isLive={item.isLive}
              isSport={isSport}
              isMix={true}
              icon={defaultSportIcon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportFloor;
